import React from 'react';

class BuilderErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('Builder error:', error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="builder-shell" style={{ padding: 32, maxWidth: 560, margin: '40px auto' }}>
          <h2 style={{ marginBottom: 12 }}>Form Builder failed to load</h2>
          <p style={{ color: '#6b7280', marginBottom: 16 }}>
            {this.state.error.message || 'An unexpected error occurred.'}
          </p>
          <button
            type="button"
            className="builder-ui-btn builder-ui-btn--primary"
            onClick={() => window.location.reload()}
          >
            Reload page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default BuilderErrorBoundary;
